import React, { useState } from 'react'
import { Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  message,
} from 'antd'
import {
  Div, H4, Input, H5, Button, P,
} from 'konsys-ui'
import { theme } from '../../styles/_variables'
import VALIDATE from '../../constants/validate'
import { CHANGE_PASSWORD } from '../../constants/graph/mutation'
import { Instruction, ChangePasswordWrapper } from './styled'

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState()
  const [newPassword, setNewPassword] = useState()
  const [newAgain, setNewAgain] = useState()
  const [success, setSuccess] = useState(false)

  const checkInput = (c, m) => {
    switch (m) {
      case 0: if (!/\s/.test(c)) {
        setOldPassword(c)
      } break
      case 1: if (!/\s/.test(c)) {
        setNewPassword(c)
      } break
      case 2: if (!/\s/.test(c)) {
        setNewAgain(c)
      } break
      default:
    }
  }

  return (
    success
      ? <Div margin='32px 0'>
          <Div textAlign='center'>
            <H4 bold margin='0 0 16px' color={theme.color.tertiaryColor}>เปลี่ยนรหัสผ่านเรียบร้อย</H4>
          </Div>
          <Div bgColor={theme.color.lightPaleGrey} padding='24px' borderRadius='20px'>
            <P display='block' textAlign='center'>เปลี่ยนรหัสผ่านใหม่เรียบร้อยแล้ว คุณสามารถใช้รหัสผ่านใหม่</P>
            <P display='block' textAlign='center'>เพื่อเข้าสู่ระบบครั้งต่อไปได้ทันที</P>
          </Div>
        </Div>
      : <ChangePasswordWrapper>
          <Div textAlign='left' width='210px'>
            <H4 margin='0 0 16px' color={theme.color.tertiaryColor}>เปลี่ยนรหัสผ่าน</H4>
          </Div>
          <Div margin='24px 0 36px' display='flex' justifyContent='flex-start'>
            <Div display='flex' flexDirection='column'>
              <H5 margin='0 0 8px' color={theme.color.primaryColor}>รหัสผ่านปัจจุบัน</H5>
              <Input value={oldPassword} type='password' onChange={e => checkInput(e.target.value, 0)}/>
            </Div>
          </Div>
          <Div>
            <Div display='flex' flexDirection='column'>
              <H5 margin='0 0 8px' color={theme.color.primaryColor}>รหัสผ่านใหม่</H5>
              <Input value={newPassword} type='password' onChange={e => checkInput(e.target.value, 1)}/>
              <Instruction>กรุณากรอกรหัสผ่านอย่างน้อย 6 ตัว ด้วยภาษาอังกฤษ ตัวเลข หรือสัญลักษณ์</Instruction>
            </Div>
            <Div display='flex' flexDirection='column'>
              <H5 margin='0 0 8px' color={theme.color.primaryColor}>รหัสผ่านใหม่ (อีกครั้ง)</H5>
              <Input value={newAgain} type='password' onChange={e => checkInput(e.target.value, 2)}/>
              <Instruction>กรุณากรอกรหัสผ่านใหม่ให้เหมือนกัน</Instruction>
            </Div>
          </Div>
          <Div margin='8px 0 0' display='flex' justifyContent='center'>
            <Mutation
              mutation={CHANGE_PASSWORD}
            >
            {doChangePassword => (
              <Button
                disabled={
                  _.isUndefined(oldPassword)
                  || _.isUndefined(newPassword)
                  || _.isUndefined(newAgain)
                  || oldPassword === newPassword
                  || newAgain !== newPassword
                  || !VALIDATE.password.test(oldPassword)
                  || !VALIDATE.password.test(newPassword)
                }
                margin='0 8px'
                inverse
                buttonStyle="round"
                color={theme.color.secondaryColor}
                text='เปลี่ยนรหัสผ่าน'
                onClick={() => {
                  doChangePassword({
                    variables: {
                      oldPassword, newPassword,
                    },
                  }).then((resp) => {
                    if (resp.data.changePassword.success) {
                      setSuccess(true)
                    } else {
                      message.error(resp.data.changePassword.message)
                    }
                  })
                }}
              />
            )
            }
            </Mutation>
          </Div>
        </ChangePasswordWrapper>
  )
}

export default ChangePassword



// WEBPACK FOOTER //
// ./src/pages/change-password/index.jsx